import React from 'react';
import { Modal, Spin } from 'antd';
import { ThemeButton, ThemeInput } from '../components';

const UpdateAppointment = ({
  isOpen,
  onClose,
  value,
  setValue,
  onClick,
  isLoading,
  btnText,
}) => {
  return (
    <Modal footer={false} open={isOpen} onCancel={onClose}>
      <div className="flex justify-between items-center my-6">
        <h1 className="text-xl font-semibold">{btnText}</h1>
        <ThemeButton
          className={'w-36'}
          content={
            <>{isLoading ? <Spin /> : <p className="text-sm">{btnText}</p>}</>
          }
          onClick={() => onClick()}
        />
      </div>
      <div>
        <ThemeInput
          placeholder="Add notes"
          value={value}
          onChange={e => setValue(e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default UpdateAppointment;
